var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.77 8.00953C39.558 3.79641 33.958 1.47656 28.0003 1.47656C22.0427 1.47656 16.4427 3.79641 12.2306 8.00953C3.53641 16.7037 3.53641 30.8514 12.2306 39.5467L26.6473 53.9623C27.0203 54.3364 27.5103 54.5234 28.0003 54.5234C28.4903 54.5234 28.9803 54.3364 29.3533 53.9623L43.77 39.5467C52.4642 30.8514 52.4642 16.7037 43.77 8.00953ZM28.0003 33.6536C25.3622 33.6536 22.8827 32.6266 21.0167 30.7617C19.1519 28.8958 18.1248 26.4162 18.1248 23.7781C18.1248 21.14 19.1519 18.6594 21.0167 16.7945C22.8827 14.9297 25.3622 13.9016 28.0003 13.9016C30.6384 13.9016 33.118 14.9297 34.9839 16.7945C38.8339 20.6456 38.8339 26.9106 34.9839 30.7617C33.118 32.6266 30.6384 33.6536 28.0003 33.6536Z",
    fill: "#10A89D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/mapIcon.4d731d2de2062831b00b99f852e90ca5.svg";
export { ForwardRef as ReactComponent };